module.exports = __webpack_public_path__ + "static/media/dove_green.5293be56.svg";